import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {ReactNode} from 'react';
import _ from 'underscore';

import colSizeClassesFromProps from './util/colSizeClassesFromProps';

interface LabelProps {
  children?: ReactNode;
  className?: string;
  required?: boolean;

  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
}

/**
 * Prefer `FieldLabel` for greenfield use cases.
 */
export default function Label(props: LabelProps): JSX.Element {
  const colSizeClasses = colSizeClassesFromProps(props);
  const classString = classNames(props.className, colSizeClasses, 'control-label', {
    required: props.required,
  });
  const excludedProps = ['required', 'xs', 'sm', 'md', 'lg'];
  return (
    // eslint-disable-next-line no-restricted-syntax
    <label {..._.omit(props, excludedProps)} className={classString}>
      {props.children}
    </label>
  );
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const propTypes: any = {
  children: PropTypes.node,
  className: PropTypes.string,
  required: PropTypes.bool,

  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
};
Label.propTypes = propTypes;
